<template>
  <div class="locale-changer">
    <!-- <select class="langBtn" v-model="$i18n.locale">
      <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{ lang }}</option>
    </select> -->
    <button class="switchBtn" @click="switchLocale($i18n.locale)" v-html="writeLocale()">change lang</button>
  </div>
</template>

<script>
export default {
  name: 'locale-changer',
  data () {
    return { 
      langs: ['en', 'fr'],
      currentLang: this.$i18n.locale
    }
  },
  methods: {
    switchLocale: function(lg) {
      if(lg == 'en') {
        this.$i18n.locale = 'fr'
      } else {
        this.$i18n.locale = 'en'
      }
    },
    writeLocale: function() {
      if(this.$i18n.locale == 'en') {
        return 'Français'
      } else {
        return 'English'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.locale-changer {
  display:inline-block;
}

select {
  font-family: 'Encode Sans', sans-serif;
}

select option {
  font-family: 'Encode Sans', sans-serif;
}

.langBtn, .switchBtn {
  color: $pink;
  text-transform: uppercase;
  border: 1px solid $pink;
  height:35px;
  padding: 5px 8px;
  border-radius:5px;
  background-color:white;
  box-shadow: 0 2px 10px 0 rgba(0,0,0,0.1);
}

@media (max-width:991px) {
  .langBtn {
    margin:0 0 0 $medium;
  }
}
</style>